const md = `# Glossary & FAQ

## Glossary

* **Workflow** — a declarative recipe (variables + ordered steps) that
  the Demo Agent's Playwright runner executes against
  \`ibuy.cloud\`.
* **Run** — one execution of a workflow.  Has a unique Run UUID and a
  human-friendly **Run Number** (\`0001\`–\`9999\`).
* **Version** — an immutable snapshot of a workflow's steps and
  variables.  Created automatically every time someone edits the
  workflow.
* **Persona** — one of *Default*, *CFO*, *Head of Procurement*, *IT
  Director*.  Controls the narration's tone and focus.
* **Auto-pipeline** — the narration + voiceover + MP4 chain that runs
  after the Playwright session finishes (if enabled).
* **Folder** — a user-defined group of runs.  Folders can be shared.
* **Share** — a public, unauthenticated token-based URL that exposes a
  single run or an entire folder.
* **PunchOut** — an industry-standard cXML round-trip where a buyer
  jumps from their procurement system into a supplier-hosted catalog,
  picks items, and returns with the cart.
* **Discovery step** — an \`evaluate_js\` step embedded in a workflow
  that dumps DOM state to \`storage/runs/<run_id>/discovery/\` for
  selector debugging.

## FAQ

### How is this different from Loom?

Loom captures whatever a *human* does on screen.  The Demo Agent
captures whatever the *workflow* does deterministically.  Same
workflow on Monday and Friday → same screenshots, same narration
script, same MP4 length.  Useful when your demo's quality needs to be
stable across people, time, and customer audiences.

### How is this different from a unit test?

A unit test asserts.  The Demo Agent *narrates*.  You can use the same
selectors for both — but the asset you get out of a Demo Agent run is
a sales-ready video, not a green check.

### Can I write a workflow that drives a different app, not Eyvo?

Yes — every workflow's first step is usually a \`navigate\` to a
specific URL, followed by a login.  Change those, change the variables,
and you have an agent for any app reachable from the Playwright
container.  The auto-pipeline, sharing, folders, and run numbers all
work identically.

### Does it cost money to run a workflow?

The Playwright session itself is free.  Narration is GPT-5.2 (≈ $0.02
per script), voiceover is ElevenLabs (≈ $0.10 per minute of audio).
Final MP4 stitching is ffmpeg → zero cost.  Skipping the auto-pipeline
gives you a free run.

### What happens to old runs?

They stick around in MongoDB indefinitely.  Their Playwright videos,
screenshots, and stitched MP4s sit on disk under
\`/app/backend/storage/runs/\`.  Nothing is GC'd automatically.

### Where do I get help?

You're reading it.  If something's still unclear, the source of truth
is the \`/app/memory/\` folder in the repo — every architectural decision
is documented there.
`;

export default md;
